function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import { PropTypes } from 'prop-types';
import { isEmpty } from 'lodash';
import { handleKeyPress } from './utils';
var ReferralProgramMenu = function ReferralProgramMenu(_ref) {
  var unselected = _ref.unselected,
    preventUngroup = _ref.preventUngroup,
    moveToNewReferralDisabled = _ref.moveToNewReferralDisabled,
    onMoveToExistingReferralClick = _ref.onMoveToExistingReferralClick,
    onMoveToExistingReferralReasonsHover = _ref.onMoveToExistingReferralReasonsHover,
    onMoveToNewReferralClick = _ref.onMoveToNewReferralClick,
    onRemoveClick = _ref.onRemoveClick,
    reasonMenuIsOpen = _ref.reasonMenuIsOpen,
    moveToReferralIndex = _ref.moveToReferralIndex,
    cannotMoveReasons = _ref.cannotMoveReasons,
    onClickThreeDotIcon = _ref.onClickThreeDotIcon,
    setReasonMenuIsOpen = _ref.setReasonMenuIsOpen;
  var reasons = cannotMoveReasons[moveToReferralIndex - 1];
  var referralOptionsMenu = useRef();
  var buttonRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showUngroupMessageError = _useState2[0],
    setShowUngroupMessageError = _useState2[1];
  useEffect(function () {
    document.addEventListener('mousedown', handleClickListener);
    return function () {
      return document.removeEventListener('mousedown', handleClickListener);
    };
  }, []);
  var handleClickListener = function handleClickListener(event) {
    var clickedInside = referralOptionsMenu && referralOptionsMenu.current.contains(event.target);
    if (!clickedInside) {
      onClickThreeDotIcon();
    }
    ;
  };
  var handleShowUngroupMessageError = function handleShowUngroupMessageError() {
    if (!showUngroupMessageError) setShowUngroupMessageError(true);else setShowUngroupMessageError(false);
  };
  var handleButtonClick = function handleButtonClick() {
    try {
      onClickThreeDotIcon();
      if (!reasonMenuIsOpen) {
        var nextElement = document.querySelector('#edit_referral_groupings').parentElement;
        if (nextElement) {
          nextElement.focus();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "absolute z-10 right-0 mt-10 mr-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row-reverse items-start"
  }, /*#__PURE__*/React.createElement("div", {
    ref: referralOptionsMenu,
    className: "shadow-lg bg-white border border-solid border-blue-border"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "cursor-pointer pl-0"
  }, unselected.map(function (index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "p-3 hover:bg-med-pale-blue"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return onMoveToExistingReferralClick(index);
      },
      onMouseEnter: function onMouseEnter() {
        return onMoveToExistingReferralReasonsHover(index);
      },
      onMouseOut: function onMouseOut() {
        return setReasonMenuIsOpen(false);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyPress(e, function () {
          return onMoveToExistingReferralClick(index);
        });
      },
      className: "w-full text-left ".concat(!isEmpty(cannotMoveReasons[index]) ? 'text-gray-400' : '')
    }, "Move to Referral ", index + 1));
  }), !moveToNewReferralDisabled ? /*#__PURE__*/React.createElement("li", {
    className: "p-3 hover:bg-med-pale-blue"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onMoveToNewReferralClick,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress(e, onMoveToNewReferralClick);
    },
    onMouseEnter: preventUngroup ? function () {
      return handleShowUngroupMessageError();
    } : null,
    onMouseOut: preventUngroup ? function () {
      return handleShowUngroupMessageError();
    } : null,
    className: "w-full text-left ".concat(preventUngroup ? 'text-gray-400' : '')
  }, "Move to new referral")) : null, /*#__PURE__*/React.createElement("li", {
    className: "p-3 hover:bg-med-pale-blue",
    onClick: onRemoveClick,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress(e, onRemoveClick);
    },
    tabIndex: 0
  }, "Remove"), /*#__PURE__*/React.createElement("li", {
    className: "p-3 hover:bg-med-pale-blue"
  }, /*#__PURE__*/React.createElement("button", {
    ref: buttonRef,
    onClick: handleButtonClick,
    onKeyDown: function onKeyDown(e) {
      return handleKeyPress(e, handleButtonClick);
    },
    "aria-expanded": reasonMenuIsOpen,
    "aria-controls": "program-menu",
    className: "w-full text-left"
  }, "Close menu")))), reasonMenuIsOpen && !isEmpty(reasons) ? /*#__PURE__*/React.createElement("div", {
    className: "mr-2 p-4 min-w-2/3 bg-med-pale-blue border border-solid border-blue-border z-30"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, "Cannot move to Referral ", moveToReferralIndex, " for the following reasons:"), /*#__PURE__*/React.createElement("ul", {
    className: "list-disc pl-0"
  }, reasons.map(function (reason, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: "text-red ml-6",
      key: "cannot-move-reason-".concat(index)
    }, reason);
  }))) : null, showUngroupMessageError ? /*#__PURE__*/React.createElement("div", {
    className: "mr-2 p-4 min-w-2/3 bg-med-pale-blue border border-solid border-blue-border z-30"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-2"
  }, "Cannot move to new referral for the following reasons:"), /*#__PURE__*/React.createElement("ul", {
    className: "list-disc pl-0"
  }, /*#__PURE__*/React.createElement("li", {
    className: "text-red ml-6"
  }, "Referrals to a program that requires authorization must be sent as a group."))) : null));
};
ReferralProgramMenu.propTypes = {
  unselected: PropTypes.array.isRequired,
  moveToNewReferralDisabled: PropTypes.bool.isRequired,
  onMoveToExistingReferralClick: PropTypes.func.isRequired,
  onMoveToNewReferralClick: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  reasonMenuIsOpen: PropTypes.bool.isRequired,
  moveToReferralIndex: PropTypes.number.isRequired,
  cannotMoveReasons: PropTypes.object,
  onClickThreeDotIcon: PropTypes.func.isRequired,
  setReasonMenuIsOpen: PropTypes.func.isRequired
};
ReferralProgramMenu.defaultProps = {
  cannotMoveReasons: {}
};
export default ReferralProgramMenu;
//# sourceMappingURL=ReferralProgramMenu.js.map